// import { lighten } from 'polished';
// import styled, { css } from 'styled-components';

// const colors = {
//   white: '#fff',
//   title: '#0f172a',
//   text: '#334155',
//   muted: '#64748b',

//   border: '#e5e7eb',
//   borderSoft: '#e2e8f0',
//   borderLight: '#f1f5f9',
//   borderDashed: '#cbd5e1',

//   bgSoft: '#f8fafc',
//   bgPill: '#f1f5f9',
//   bgInfo: '#eff6ff',

//   blue: '#2563eb',
//   blueStrong: '#1d4ed8',
//   green: '#16a34a',
//   disabled: '#94a3b8',
// };

// const radius = {
//   md: '8px',
//   lg: '10px',
//   xl: '12px',
//   pill: '999px',
// };

// const shadow = {
//   card: '0 8px 24px rgba(15, 23, 42, 0.08)',
//   soft: '0 3px 10px rgba(15, 23, 42, 0.05)',
//   blue: '0 4px 12px rgba(37, 99, 235, 0.25)',
//   green: '0 4px 12px rgba(22, 163, 74, 0.25)',
// };

// const cardBase = css`
//   background: ${colors.white};
//   border: 1px solid ${colors.border};
//   border-radius: ${radius.xl};
//   box-shadow: ${shadow.card};
// `;

// const actionButtonBase = css`
//   border: none;
//   border-radius: ${radius.md};
//   padding: 10px 14px;
//   color: ${colors.white};
//   display: flex;
//   align-items: center;
//   gap: 8px;
// `;

// export const MasterWrapper = styled.div`
//   display: grid;
//   grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
//   gap: 24px;
//   align-items: start;
//   height: calc(100vh - 220px);
//   min-height: 520px;
// `;

// export const LeftWrapper = styled.div`
//   ${cardBase};
//   padding: 20px;
//   position: sticky;
//   top: 0;
//   align-self: start;
// `;

// export const LeftContainer = styled.div`
//   margin-bottom: 18px;
// `;

// export const RightWrapper = styled.div`
//   height: 100%;
//   overflow-y: auto;
//   padding-right: 6px;
// `;

// export const RightContainer = styled.div`
//   ${cardBase};
//   padding: 20px;
// `;

// export const RightTitleContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 12px;
//   margin-bottom: 16px;
//   padding-bottom: 12px;
//   border-bottom: 1px solid ${colors.borderLight};
// `;

// export const Title = styled.h3`
//   margin: 0;
//   font-size: 18px;
//   font-weight: 600;
//   color: ${colors.title};
// `;

// export const Span = styled.span`
//   display: block;
//   margin-top: 4px;
//   font-size: 13px;
//   color: ${colors.muted};
// `;

// export const ContainerSpanAndButton = styled.div`
//   display: flex;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 10px;

//   span {
//     min-width: 32px;
//     height: 32px;
//     padding: 0 10px;
//     border-radius: ${radius.pill};
//     background: ${colors.bgInfo};
//     color: ${colors.blueStrong};
//     font-size: 13px;
//     font-weight: 700;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }

//   button {
//     ${actionButtonBase};
//     background: ${({ $hasCatalogo }) =>
//       $hasCatalogo ? colors.green : colors.disabled};
//     cursor: ${({ $hasCatalogo }) => ($hasCatalogo ? 'pointer' : 'not-allowed')};
//     box-shadow: ${({ $hasCatalogo }) => ($hasCatalogo ? shadow.green : 'none')};
//     cursor: pointer;
//     transition: all 0.25s ease;

//     :hover {
//       color: #fff;
//       background: ${lighten(0.08, colors.green)};
//       box-shadow: 0 6px 13px rgb(22, 163, 74, 0.5);
//       transform: translateY(-1px);
//     }
//   }
// `;

// export const WrapperList = styled.div`
//   display: grid;
//   gap: 16px;
// `;

// export const ContainerList = styled.div`
//   padding: 16px;
//   border: 1px solid ${colors.borderSoft};
//   border-radius: ${radius.xl};
//   background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);
//   box-shadow: ${shadow.soft};
// `;

// export const HeaderContainerList = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-start;
//   flex-wrap: wrap;
//   gap: 12px;
//   margin-bottom: 14px;

//   div {
//     flex: 1;
//     min-width: 220px;
//   }
// `;

// export const TitleModeloAndCatalogo = styled.div`
//   font-size: 16px;
//   font-weight: 600;
//   color: ${colors.title};
//   margin-bottom: 4px;
// `;

// export const PageInfo = styled.div`
//   font-size: 13px;
//   color: ${colors.muted};
// `;

// export const ContainerCatalogoAndButton = styled.div`
//   display: flex;
//   gap: 8px;
//   align-items: center;
//   flex-wrap: wrap;
//   justify-content: flex-end;

//   span {
//     white-space: nowrap;
//     padding: 4px 10px;
//     border-radius: ${radius.pill};
//     background: ${colors.bgPill};
//     color: ${colors.text};
//     font-size: 12px;
//     font-weight: 600;
//   }

//   button {
//     ${actionButtonBase};
//     background: ${colors.blue};
//     font-size: 13px;
//     font-weight: 600;
//     cursor: pointer;
//     box-shadow: ${shadow.blue};
//     cursor: pointer;
//     transition: all 0.25s ease;

//     :hover {
//       color: #fff;
//       background: ${lighten(0.08, colors.blue)};
//       box-shadow: 0 6px 13px rgb(37, 99, 235, 0.5);
//       transform: translateY(-1px);
//     }
//   }
// `;

// export const WrapperLineList = styled.div`
//   border-top: 1px solid ${colors.border};
//   padding-top: 14px;
//   display: grid;
//   gap: 10px;
// `;

// export const ContainerLineList = styled.div`
//   display: flex;
//   gap: 10px;
//   flex-wrap: wrap;
//   align-items: stretch;
// `;

// export const BoxInfoHeader = styled.div`
//   padding: 0 0 4px 2px;
//   border-bottom: 1px dashed ${colors.borderDashed};
//   font-size: 13px;
//   color: ${colors.text};
//   font-weight: 600;
//   flex: ${({ $minWidth120 }) => ($minWidth120 ? 'none' : '1')};
//   min-width: ${({ $minWidth120 }) => ($minWidth120 ? '70px' : '220px')};
// `;

// export const BoxInfoLineList = styled.div`
//   display: ${({ $center }) => ($center ? 'flex' : '')};
//   justify-content: ${({ $center }) => ($center ? 'center' : '')};
//   align-items: ${({ $center }) => ($center ? 'center' : '')};
//   padding: 8px 12px;
//   border-radius: ${radius.md};
//   background: ${colors.bgSoft};
//   border: 1px solid #e2e8fc;
//   font-size: 13px;
//   color: ${colors.text};
//   flex: ${({ $minWidth120 }) => ($minWidth120 ? 'none' : '1')};
//   min-width: ${({ $minWidth120 }) => ($minWidth120 ? '70px' : '220px')};
// `;

// export const CardEmptyList = styled.div`
//   padding: 16px;
//   border: 1px dashed ${colors.borderDashed};
//   border-radius: ${radius.lg};
//   background: ${colors.bgSoft};
//   text-align: center;
//   color: ${colors.muted};
//   font-size: 14px;
// `;

// export const UpdateList = styled.div`
//   padding-top: 26px;
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
// `;

// export const UpdateItem = styled.div`
//   padding: 12px;
//   border-radius: ${radius.md};

//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 16px;

//   border: ${({ $status }) =>
//     $status === 1 ? '1px solid #22c55e' : '1px solid #e2e8fc'};

//   background: ${({ $status }) => ($status === 1 ? '#f0fdf4' : colors.bgSoft)};

//   @media (max-width: 600px) {
//     align-items: flex-start;
//     flex-direction: column;
//   }
// `;

// export const UpdateInfo = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
//   min-width: 0;
// `;

// export const InfoRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   gap: 6px;

//   font-size: 13px;
//   color: ${colors.text};

//   strong {
//     font-weight: 600;
//     color: ${colors.muted};
//     white-space: nowrap;
//   }

//   span {
//     text-align: left;
//     word-break: break-word;
//   }
// `;

// export const EmptyList = styled.div`
//   padding: 16px;
//   border: 1px dashed ${colors.borderDashed};
//   border-radius: ${radius.lg};
//   background: ${colors.bgSoft};
//   text-align: center;
//   color: ${colors.muted};
//   font-size: 14px;
// `;

// export const WrapperButtonsAction = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
//   margin-left: auto;
//   flex-shrink: 0;

//   @media (max-width: 600px) {
//     width: 100%;
//     justify-content: flex-end;
//   }
// `;

// export const ButtonAction = styled.button`
//   width: 80px;
//   padding: 5px;
//   border-radius: 5px;
//   border: none;
//   cursor: pointer;

//   background: ${({ $isAprove }) => ($isAprove ? '#34d399' : '#e5e7eb')};
//   color: ${({ $isAprove }) => ($isAprove ? '#fff' : '#9ca3af')};

//   box-shadow: ${shadow.soft};
// `;

import { lighten } from 'polished';
import styled, { css } from 'styled-components';

const colors = {
  white: '#fff',
  title: '#0f172a',
  text: '#334155',
  muted: '#64748b',

  border: '#e5e7eb',
  borderSoft: '#e2e8f0',
  borderLight: '#f1f5f9',
  borderDashed: '#cbd5e1',

  bgSoft: '#f8fafc',
  bgPill: '#f1f5f9',
  bgInfo: '#eff6ff',

  blue: '#2563eb',
  blueStrong: '#1d4ed8',
  green: '#16a34a',
  disabled: '#94a3b8',
};

const radius = {
  md: '8px',
  lg: '10px',
  xl: '12px',
  pill: '999px',
};

const shadow = {
  card: '0 8px 24px rgba(15, 23, 42, 0.08)',
  soft: '0 3px 10px rgba(15, 23, 42, 0.05)',
  blue: '0 4px 12px rgba(37, 99, 235, 0.25)',
  green: '0 4px 12px rgba(22, 163, 74, 0.25)',
};

const cardBase = css`
  background: ${colors.white};
  border: 1px solid ${colors.border};
  border-radius: ${radius.xl};
  box-shadow: ${shadow.card};
`;

const actionButtonBase = css`
  border: none;
  border-radius: ${radius.md};
  padding: 10px 14px;
  color: ${colors.white};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MasterWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
  height: calc(100vh - 220px);
  min-height: 520px;
`;

export const LeftWrapper = styled.div`
  ${cardBase};
  padding: 20px;
  position: sticky;
  top: 0;
  align-self: start;
`;

export const LeftContainer = styled.div`
  margin-bottom: 18px;
`;

export const RightWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-right: 6px;
`;

export const RightContainer = styled.div`
  ${cardBase};
  padding: 20px;
`;

export const RightTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${colors.borderLight};
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.title};
`;

export const Span = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: ${colors.muted};
`;

export const ContainerSpanAndButton = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  span {
    min-width: 32px;
    height: 32px;
    padding: 0 10px;
    border-radius: ${radius.pill};
    background: ${colors.bgInfo};
    color: ${colors.blueStrong};
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button {
    ${actionButtonBase};
    background: ${({ $hasCatalogo }) =>
      $hasCatalogo ? colors.green : colors.disabled};
    cursor: ${({ $hasCatalogo }) => ($hasCatalogo ? 'pointer' : 'not-allowed')};
    box-shadow: ${({ $hasCatalogo }) => ($hasCatalogo ? shadow.green : 'none')};
    cursor: pointer;
    transition: all 0.25s ease;

    :hover {
      color: #fff;
      background: ${lighten(0.08, colors.green)};
      box-shadow: 0 6px 13px rgb(22, 163, 74, 0.5);
      transform: translateY(-1px);
    }
  }
`;

export const WrapperList = styled.div`
  display: grid;
  gap: 16px;
`;

export const ContainerList = styled.div`
  padding: 16px;
  border: 1px solid ${colors.borderSoft};
  border-radius: ${radius.xl};
  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);
  box-shadow: ${shadow.soft};
`;

export const HeaderContainerList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;

  div {
    flex: 1;
    min-width: 220px;
  }
`;

export const TitleModeloAndCatalogo = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.title};
  margin-bottom: 4px;
`;

export const PageInfo = styled.div`
  font-size: 13px;
  color: ${colors.muted};
`;

export const ContainerCatalogoAndButton = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;

  span {
    white-space: nowrap;
    padding: 4px 10px;
    border-radius: ${radius.pill};
    background: ${colors.bgPill};
    color: ${colors.text};
    font-size: 12px;
    font-weight: 600;
  }

  button {
    ${actionButtonBase};
    background: ${colors.blue};
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: ${shadow.blue};
    cursor: pointer;
    transition: all 0.25s ease;

    :hover {
      color: #fff;
      background: ${lighten(0.08, colors.blue)};
      box-shadow: 0 6px 13px rgb(37, 99, 235, 0.5);
      transform: translateY(-1px);
    }
  }
`;

export const WrapperLineList = styled.div`
  border-top: 1px solid ${colors.border};
  padding-top: 14px;
  display: grid;
  gap: 10px;
`;

export const ContainerLineList = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: stretch;
`;

export const BoxInfoHeader = styled.div`
  padding: 0 0 4px 2px;
  border-bottom: 1px dashed ${colors.borderDashed};
  font-size: 13px;
  color: ${colors.text};
  font-weight: 600;
  flex: ${({ $minWidth120 }) => ($minWidth120 ? 'none' : '1')};
  min-width: ${({ $minWidth120 }) => ($minWidth120 ? '70px' : '220px')};
`;

export const BoxInfoLineList = styled.div`
  display: ${({ $center }) => ($center ? 'flex' : '')};
  justify-content: ${({ $center }) => ($center ? 'center' : '')};
  align-items: ${({ $center }) => ($center ? 'center' : '')};
  padding: 8px 12px;
  border-radius: ${radius.md};
  background: ${colors.bgSoft};
  border: 1px solid #e2e8fc;
  font-size: 13px;
  color: ${colors.text};
  flex: ${({ $minWidth120 }) => ($minWidth120 ? 'none' : '1')};
  min-width: ${({ $minWidth120 }) => ($minWidth120 ? '70px' : '220px')};
`;

export const CardEmptyList = styled.div`
  padding: 16px;
  border: 1px dashed ${colors.borderDashed};
  border-radius: ${radius.lg};
  background: ${colors.bgSoft};
  text-align: center;
  color: ${colors.muted};
  font-size: 14px;
`;

export const UpdateList = styled.div`
  padding-top: 26px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const UpdateItem = styled.div`
  padding: 12px;
  border-radius: ${radius.md};

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  border: ${({ $status }) =>
    $status === 1 ? '1px solid #22c55e' : '1px solid #e2e8fc'};

  background: ${({ $status }) => ($status === 1 ? '#f0fdf4' : colors.bgSoft)};

  @media (max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const UpdateInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;

  font-size: 13px;
  color: ${colors.text};

  strong {
    font-weight: 600;
    color: ${colors.muted};
    white-space: nowrap;
  }

  span {
    text-align: left;
    word-break: break-word;
  }
`;

export const EmptyList = styled.div`
  padding: 16px;
  border: 1px dashed ${colors.borderDashed};
  border-radius: ${radius.lg};
  background: ${colors.bgSoft};
  text-align: center;
  color: ${colors.muted};
  font-size: 14px;
`;

export const WrapperButtonsAction = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;

  @media (max-width: 600px) {
    width: 100%;
    justify-content: flex-end;
  }
`;

export const ImagemUploadWrapper = styled.div`
  margin-top: 20px;
  padding: 16px;
  border: 1px dashed ${colors.borderDashed};
  border-radius: ${radius.lg};
  background: ${colors.bgSoft};
`;

export const ImagemUploadRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 10px;

  select,
  input[type='file'] {
    padding: 8px 10px;
    border-radius: ${radius.md};
    border: 1px solid ${colors.border};
    font-size: 13px;
    background: ${colors.white};
  }
`;

export const ImagemPreviewText = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: ${colors.muted};
`;

export const ImagemUploadButton = styled.button`
  ${actionButtonBase};
  background: ${colors.blue};
  font-size: 13px;
  font-weight: 600;
  box-shadow: ${shadow.blue};
  transition: all 0.25s ease;

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};

  :hover {
    background: ${({ disabled }) =>
      disabled ? colors.blue : lighten(0.08, colors.blue)};
  }
`;

export const ButtonAction = styled.button`
  width: 80px;
  padding: 5px;
  border-radius: 5px;
  border: none;
  cursor: pointer;

  background: ${({ $isAprove }) => ($isAprove ? '#34d399' : '#e5e7eb')};
  color: ${({ $isAprove }) => ($isAprove ? '#fff' : '#9ca3af')};

  box-shadow: ${shadow.soft};
`;
